export enum FundraisingDocumentationType {
  DEFAULT = 'DEFAULT',
  TEMPLATE = 'TEMPLATE',
}

export type INewFundraisingDocumentationForm = {
  documentationType: FundraisingDocumentationType;
  templateFile?: string;
};
